import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, timer, Subject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { getWindow } from 'ssr-window';
import { DeviceDetectorService } from './device-detector.service';
@Injectable({ providedIn: 'root' })
export class IdleService {

    private idleTimeout = 3 * 60 * 60 * 1000; // 3 hours
    private warningTime = 1 * 60 * 1000;      // last 1 minute
    private lastActivityTime = Date.now();

    private warningSubject = new Subject<number>();
    private timeoutSubject = new Subject<void>();

    warning$ = this.warningSubject.asObservable();
    timeout$ = this.timeoutSubject.asObservable();

    constructor(private ngZone: NgZone, private deviceDetector: DeviceDetectorService) { }

    startWatching() {
        this.ngZone.runOutsideAngular(() => {

            const activityEvents = merge(
                fromEvent(window, 'mousemove'),
                fromEvent(window, 'keydown'),
                fromEvent(window, 'click'),
                fromEvent(window, 'touchstart'),
                fromEvent(window, 'scroll')
            );

            activityEvents.pipe(
                debounceTime(300),
                tap(() => this.resetTimer())
            ).subscribe();

            this.checkLoop();
        });
    }

    private resetTimer() {
        this.lastActivityTime = Date.now();
    }

    private checkLoop() {
        timer(0, 1000).subscribe(() => {
            const now = Date.now();
            const inactiveFor = now - this.lastActivityTime;

            // LAST 1 MINUTE — send countdown
            if (
                inactiveFor >= this.idleTimeout - this.warningTime &&
                inactiveFor < this.idleTimeout
            ) {
                const remaining = Math.round(
                    (this.idleTimeout - inactiveFor) / 1000
                );
                this.warningSubject.next(remaining);
            }

            // TIMEOUT — auto logout
            if (inactiveFor >= this.idleTimeout) {
                this.timeoutSubject.next();
            }
        });
    }
}
